"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
var _AdresseBase = _interopRequireDefault(require("./AdresseBase"));
var _DateiBase = _interopRequireDefault(require("./DateiBase"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * KFV LDS API
 * Die KFV LDS API bietet eine Schnittstelle zum Backend der PWA.
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

/**
 * The FeuerwehrCreate model module.
 * @module model/FeuerwehrCreate
 * @version 0.0.1
 */
class FeuerwehrCreate {
  /**
   * Constructs a new <code>FeuerwehrCreate</code>.
   * @alias module:model/FeuerwehrCreate
   * @param name {String} 
   * @param typ {String} 
   */
  constructor(name, typ) {
    FeuerwehrCreate.initialize(this, name, typ);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  static initialize(obj, name, typ) {
    obj['name'] = name;
    obj['typ'] = typ;
  }

  /**
   * Constructs a <code>FeuerwehrCreate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/FeuerwehrCreate} obj Optional instance to populate.
   * @return {module:model/FeuerwehrCreate} The populated <code>FeuerwehrCreate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new FeuerwehrCreate();
      if (data.hasOwnProperty('name')) {
        obj['name'] = _ApiClient.default.convertToType(data['name'], 'String');
      }
      if (data.hasOwnProperty('typ')) {
        obj['typ'] = _ApiClient.default.convertToType(data['typ'], 'String');
      }
      if (data.hasOwnProperty('link')) {
        obj['link'] = _ApiClient.default.convertToType(data['link'], 'String');
      }
      if (data.hasOwnProperty('ortslink')) {
        obj['ortslink'] = _ApiClient.default.convertToType(data['ortslink'], 'String');
      }
      if (data.hasOwnProperty('ortswehrfuehrer_name')) {
        obj['ortswehrfuehrer_name'] = _ApiClient.default.convertToType(data['ortswehrfuehrer_name'], 'String');
      }
      if (data.hasOwnProperty('ortswehrfuehrer_email')) {
        obj['ortswehrfuehrer_email'] = _ApiClient.default.convertToType(data['ortswehrfuehrer_email'], 'String');
      }
      if (data.hasOwnProperty('ortswehrfuehrer_telefon')) {
        obj['ortswehrfuehrer_telefon'] = _ApiClient.default.convertToType(data['ortswehrfuehrer_telefon'], 'String');
      }
      if (data.hasOwnProperty('leiter_name')) {
        obj['leiter_name'] = _ApiClient.default.convertToType(data['leiter_name'], 'String');
      }
      if (data.hasOwnProperty('leiter_email')) {
        obj['leiter_email'] = _ApiClient.default.convertToType(data['leiter_email'], 'String');
      }
      if (data.hasOwnProperty('leiter_telefon')) {
        obj['leiter_telefon'] = _ApiClient.default.convertToType(data['leiter_telefon'], 'String');
      }
      if (data.hasOwnProperty('ortsjugendwart_name')) {
        obj['ortsjugendwart_name'] = _ApiClient.default.convertToType(data['ortsjugendwart_name'], 'String');
      }
      if (data.hasOwnProperty('ortsjugendwart_email')) {
        obj['ortsjugendwart_email'] = _ApiClient.default.convertToType(data['ortsjugendwart_email'], 'String');
      }
      if (data.hasOwnProperty('ortsjugendwart_telefon')) {
        obj['ortsjugendwart_telefon'] = _ApiClient.default.convertToType(data['ortsjugendwart_telefon'], 'String');
      }
      if (data.hasOwnProperty('leiterkinder_name')) {
        obj['leiterkinder_name'] = _ApiClient.default.convertToType(data['leiterkinder_name'], 'String');
      }
      if (data.hasOwnProperty('leiterkinder_email')) {
        obj['leiterkinder_email'] = _ApiClient.default.convertToType(data['leiterkinder_email'], 'String');
      }
      if (data.hasOwnProperty('leiterkinder_telefon')) {
        obj['leiterkinder_telefon'] = _ApiClient.default.convertToType(data['leiterkinder_telefon'], 'String');
      }
      if (data.hasOwnProperty('verwalter')) {
        obj['verwalter'] = _ApiClient.default.convertToType(data['verwalter'], [Object]);
      }
      if (data.hasOwnProperty('gemeinde_id')) {
        obj['gemeinde_id'] = _ApiClient.default.convertToType(data['gemeinde_id'], 'Number');
      }
      if (data.hasOwnProperty('adresse')) {
        obj['adresse'] = _AdresseBase.default.constructFromObject(data['adresse']);
      }
      if (data.hasOwnProperty('dienstplan')) {
        obj['dienstplan'] = _DateiBase.default.constructFromObject(data['dienstplan']);
      }
      if (data.hasOwnProperty('bild')) {
        obj['bild'] = _DateiBase.default.constructFromObject(data['bild']);
      }
    }
    return obj;
  }

  /**
   * Validates the JSON data with respect to <code>FeuerwehrCreate</code>.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FeuerwehrCreate</code>.
   */
  static validateJSON(data) {
    // check to make sure all required properties are present in the JSON string
    for (const property of FeuerwehrCreate.RequiredProperties) {
      if (!data[property]) {
        throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
      }
    }
    // ensure the json data is a string
    if (data['name'] && !(typeof data['name'] === 'string' || data['name'] instanceof String)) {
      throw new Error("Expected the field `name` to be a primitive type in the JSON string but got " + data['name']);
    }
    // ensure the json data is a string
    if (data['typ'] && !(typeof data['typ'] === 'string' || data['typ'] instanceof String)) {
      throw new Error("Expected the field `typ` to be a primitive type in the JSON string but got " + data['typ']);
    }
    // ensure the json data is a string
    if (data['link'] && !(typeof data['link'] === 'string' || data['link'] instanceof String)) {
      throw new Error("Expected the field `link` to be a primitive type in the JSON string but got " + data['link']);
    }
    // ensure the json data is a string
    if (data['ortslink'] && !(typeof data['ortslink'] === 'string' || data['ortslink'] instanceof String)) {
      throw new Error("Expected the field `ortslink` to be a primitive type in the JSON string but got " + data['ortslink']);
    }
    // ensure the json data is a string
    if (data['ortswehrfuehrer_name'] && !(typeof data['ortswehrfuehrer_name'] === 'string' || data['ortswehrfuehrer_name'] instanceof String)) {
      throw new Error("Expected the field `ortswehrfuehrer_name` to be a primitive type in the JSON string but got " + data['ortswehrfuehrer_name']);
    }
    // ensure the json data is a string
    if (data['ortswehrfuehrer_email'] && !(typeof data['ortswehrfuehrer_email'] === 'string' || data['ortswehrfuehrer_email'] instanceof String)) {
      throw new Error("Expected the field `ortswehrfuehrer_email` to be a primitive type in the JSON string but got " + data['ortswehrfuehrer_email']);
    }
    // ensure the json data is a string
    if (data['ortswehrfuehrer_telefon'] && !(typeof data['ortswehrfuehrer_telefon'] === 'string' || data['ortswehrfuehrer_telefon'] instanceof String)) {
      throw new Error("Expected the field `ortswehrfuehrer_telefon` to be a primitive type in the JSON string but got " + data['ortswehrfuehrer_telefon']);
    }
    // ensure the json data is a string
    if (data['leiter_name'] && !(typeof data['leiter_name'] === 'string' || data['leiter_name'] instanceof String)) {
      throw new Error("Expected the field `leiter_name` to be a primitive type in the JSON string but got " + data['leiter_name']);
    }
    // ensure the json data is a string
    if (data['leiter_email'] && !(typeof data['leiter_email'] === 'string' || data['leiter_email'] instanceof String)) {
      throw new Error("Expected the field `leiter_email` to be a primitive type in the JSON string but got " + data['leiter_email']);
    }
    // ensure the json data is a string
    if (data['leiter_telefon'] && !(typeof data['leiter_telefon'] === 'string' || data['leiter_telefon'] instanceof String)) {
      throw new Error("Expected the field `leiter_telefon` to be a primitive type in the JSON string but got " + data['leiter_telefon']);
    }
    // ensure the json data is a string
    if (data['ortsjugendwart_name'] && !(typeof data['ortsjugendwart_name'] === 'string' || data['ortsjugendwart_name'] instanceof String)) {
      throw new Error("Expected the field `ortsjugendwart_name` to be a primitive type in the JSON string but got " + data['ortsjugendwart_name']);
    }
    // ensure the json data is a string
    if (data['ortsjugendwart_email'] && !(typeof data['ortsjugendwart_email'] === 'string' || data['ortsjugendwart_email'] instanceof String)) {
      throw new Error("Expected the field `ortsjugendwart_email` to be a primitive type in the JSON string but got " + data['ortsjugendwart_email']);
    }
    // ensure the json data is a string
    if (data['ortsjugendwart_telefon'] && !(typeof data['ortsjugendwart_telefon'] === 'string' || data['ortsjugendwart_telefon'] instanceof String)) {
      throw new Error("Expected the field `ortsjugendwart_telefon` to be a primitive type in the JSON string but got " + data['ortsjugendwart_telefon']);
    }
    // ensure the json data is a string
    if (data['leiterkinder_name'] && !(typeof data['leiterkinder_name'] === 'string' || data['leiterkinder_name'] instanceof String)) {
      throw new Error("Expected the field `leiterkinder_name` to be a primitive type in the JSON string but got " + data['leiterkinder_name']);
    }
    // ensure the json data is a string
    if (data['leiterkinder_email'] && !(typeof data['leiterkinder_email'] === 'string' || data['leiterkinder_email'] instanceof String)) {
      throw new Error("Expected the field `leiterkinder_email` to be a primitive type in the JSON string but got " + data['leiterkinder_email']);
    }
    // ensure the json data is a string
    if (data['leiterkinder_telefon'] && !(typeof data['leiterkinder_telefon'] === 'string' || data['leiterkinder_telefon'] instanceof String)) {
      throw new Error("Expected the field `leiterkinder_telefon` to be a primitive type in the JSON string but got " + data['leiterkinder_telefon']);
    }
    // ensure the json data is an array
    if (!Array.isArray(data['verwalter'])) {
      throw new Error("Expected the field `verwalter` to be an array in the JSON data but got " + data['verwalter']);
    }
    // validate the optional field `adresse`
    if (data['adresse']) {
      // data not null
      _AdresseBase.default.validateJSON(data['adresse']);
    }
    // validate the optional field `dienstplan`
    if (data['dienstplan']) {
      // data not null
      _DateiBase.default.validateJSON(data['dienstplan']);
    }
    // validate the optional field `bild`
    if (data['bild']) {
      // data not null
      _DateiBase.default.validateJSON(data['bild']);
    }
    return true;
  }
}
FeuerwehrCreate.RequiredProperties = ["name", "typ"];

/**
 * @member {String} name
 */
FeuerwehrCreate.prototype['name'] = undefined;

/**
 * @member {String} typ
 */
FeuerwehrCreate.prototype['typ'] = undefined;

/**
 * @member {String} link
 */
FeuerwehrCreate.prototype['link'] = undefined;

/**
 * @member {String} ortslink
 */
FeuerwehrCreate.prototype['ortslink'] = undefined;

/**
 * @member {String} ortswehrfuehrer_name
 */
FeuerwehrCreate.prototype['ortswehrfuehrer_name'] = undefined;

/**
 * @member {String} ortswehrfuehrer_email
 */
FeuerwehrCreate.prototype['ortswehrfuehrer_email'] = undefined;

/**
 * @member {String} ortswehrfuehrer_telefon
 */
FeuerwehrCreate.prototype['ortswehrfuehrer_telefon'] = undefined;

/**
 * @member {String} leiter_name
 */
FeuerwehrCreate.prototype['leiter_name'] = undefined;

/**
 * @member {String} leiter_email
 */
FeuerwehrCreate.prototype['leiter_email'] = undefined;

/**
 * @member {String} leiter_telefon
 */
FeuerwehrCreate.prototype['leiter_telefon'] = undefined;

/**
 * @member {String} ortsjugendwart_name
 */
FeuerwehrCreate.prototype['ortsjugendwart_name'] = undefined;

/**
 * @member {String} ortsjugendwart_email
 */
FeuerwehrCreate.prototype['ortsjugendwart_email'] = undefined;

/**
 * @member {String} ortsjugendwart_telefon
 */
FeuerwehrCreate.prototype['ortsjugendwart_telefon'] = undefined;

/**
 * @member {String} leiterkinder_name
 */
FeuerwehrCreate.prototype['leiterkinder_name'] = undefined;

/**
 * @member {String} leiterkinder_email
 */
FeuerwehrCreate.prototype['leiterkinder_email'] = undefined;

/**
 * @member {String} leiterkinder_telefon
 */
FeuerwehrCreate.prototype['leiterkinder_telefon'] = undefined;

/**
 * @member {Array.<Object>} verwalter
 */
FeuerwehrCreate.prototype['verwalter'] = undefined;

/**
 * @member {Number} gemeinde_id
 */
FeuerwehrCreate.prototype['gemeinde_id'] = undefined;

/**
 * @member {module:model/AdresseBase} adresse
 */
FeuerwehrCreate.prototype['adresse'] = undefined;

/**
 * @member {module:model/DateiBase} dienstplan
 */
FeuerwehrCreate.prototype['dienstplan'] = undefined;

/**
 * @member {module:model/DateiBase} bild
 */
FeuerwehrCreate.prototype['bild'] = undefined;
var _default = exports.default = FeuerwehrCreate;